import React from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import Github from "../assets/icon/Github";
import Facebook from "../assets/icon/Facebook";
import { HashLink } from "react-router-hash-link";
import Linkedin from "../assets/icon/Linkedin";
import GitLab from "../assets/icon/GitLab";
const Home = () => {
  const cssHoverText =
    "inline-block transition-all duration-300 text-l hover:text-green-400 hover:translate-y-[-8px] cursor-grabbing";
  AOS.init();
  return (
    <section
      className="min-h-[100vh] max-h-[100vh] flex justify-between items-center px-[3%]"
      id="home"
    >
      <div className="flex flex-col">
        <p
          className="xs:text-[26px] text-[20px] text-gray-400"
          data-aos="fade-right"
          data-aos-duration="800"
        >
          Hello, I'm
        </p>
        <h1
          className="font-extrabold sm:text-[100px] xs:text-[80px] text-[60px] whitespace-nowrap"
          data-aos="fade-right"
          data-aos-delay="150"
          data-aos-duration="800"
        >
          <span className={`${cssHoverText}`}>L</span>
          <span className={`${cssHoverText}`}>e</span>
          <span className={`${cssHoverText} ml-6`}>D</span>
          <span className={`${cssHoverText}`}>u</span>
          <span className={`${cssHoverText}`}>c</span>
          <span className={`${cssHoverText}`}></span>
          <span className={`${cssHoverText} ml-6`}>H</span>
          <span className={`${cssHoverText}`}>a</span>
          <span className={`${cssHoverText}`}>i</span>
        </h1>
        <h2
          className="text-[#00ff85] mt-7 xs:text-[22px] text-[16px] uppercase font-medium tracking-wider"
          data-aos="fade-right"
          data-aos-delay="250"
          data-aos-duration="800"
        >
          Front End Web Developer
        </h2>
        <h3
          className="xs:text-[18px] text-[16px] mt-3 text-gray-400"
          data-aos="fade-right"
          data-aos-delay="250"
          data-aos-duration="800"
        >
          3 Years of Experience
        </h3>
        <HashLink
          smooth
          to="#contact"
          className="bg-[#14c25c] px-10 py-4 text-[white] mt-6 text-[20px] font-semibold rounded-xl max-w-max"
          data-aos="fade-right"
          data-aos-delay="350"
          data-aos-duration="800"
        >
          Contact
        </HashLink>
        <div
          className="flex mt-6"
          data-aos="fade-right"
          data-aos-delay="450"
          data-aos-duration="800"
        >
          <Facebook></Facebook>
          <Linkedin></Linkedin>
          <Github></Github>
        </div>
      </div>
      <div
        className="w-[35%]"
        data-aos="fade-left"
        data-aos-delay="150"
        data-aos-duration="1000"
      >
        {/* <img src="iconbanner.svg" alt="iconbanner" className="w-full h-full" /> */}
        <div className="w-[200px] h-[200px] stage hidden lg:block">
          <div className="cubespinner">
            <div className="flex justify-center bg-white bg-opacity-30 ite face1">
              <img
                src="React-icon.png"
                alt="reactjs"
                className="w-[55%] h-auto object-contain"
              />
            </div>
            <div className="flex justify-center bg-white bg-opacity-30 ite face2">
              <img
                src="JS.png"
                alt="javascript"
                className="w-[55%] h-auto object-contain"
              />
            </div>
            <div className="flex justify-center bg-white bg-opacity-30 ite face3">
              <img
                src="redux.svg"
                alt="redux"
                className="w-[65%] h-auto object-contain"
              />
            </div>
            <div className="flex justify-center bg-white bg-opacity-30 ite face4">
              <img
                src="Nodejs.svg"
                alt="nodejs"
                className="w-[70%] h-auto object-contain"
              />
            </div>
            <div className="flex justify-center bg-white bg-opacity-30 ite face5">
              <img
                src="docker.webp"
                alt="docker"
                className="w-[60%] h-auto object-contain"
              />
            </div>
            <div className="flex justify-center bg-white bg-opacity-30 ite face6">
              <img
                src="htmlicon.png"
                alt="html"
                className="w-[60%] h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
